import React, { useEffect, useState } from "react";
import { Modal, Input, message } from "antd";
import { UserCheck } from "lucide-react";
import WebUtils from "../../../../utils/WebUtils";
import { updateCandidateDetailsApi } from "../../../../api/org-admin";

const EditStudentModal = ({
  open,
  setOpen,
  student,
  onSuccess,
  setLoading,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (student && open) {
      setFirstName(student?.firstName || "");
      setLastName(student?.lastName || "");
      setMobileNumber(student?.mobileNumber || "");
    }
  }, [student, open]);

  const handleSave = () => {
    if (!firstName.trim()) {
      message.error("Please enter first name");
      return;
    }
    if (!lastName.trim()) {
      message.error("Please enter last name");
      return;
    }

    const userIdentifier =
      student?.userIdentifier || student?.userId || student?.candidateId;

    if (!userIdentifier) {
      message.error("User identifier not found");
      return;
    }

    const payload = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      mobileNumber: mobileNumber?.trim() || "",
      countryCode: student?.countryCode || "+91",
      userIdentifier: userIdentifier,
    };

    setSubmitting(true);
    if (setLoading) setLoading(true);

    WebUtils.httpOperations(updateCandidateDetailsApi, payload, "POST")
      .then((res) => {
        setSubmitting(false);
        if (setLoading) setLoading(false);
        if (
          res?.data?.resultStatusInfo?.resultCode?.toLowerCase() === "success"
        ) {
          message.success(
            res?.data?.resultStatusInfo?.message ||
              "Candidate details updated successfully"
          );
          setOpen(false);
          if (onSuccess) {
            onSuccess();
          }
        } else {
          message.error(
            res?.data?.resultStatusInfo?.message ||
              "Failed to update candidate details"
          );
        }
      })
      .catch((err) => {
        setSubmitting(false);
        if (setLoading) setLoading(false);
        console.error("Error updating candidate details:", err);
        message.error("An error occurred while updating candidate details");
      });
  };

  return (
    <Modal
      open={open}
      onCancel={() => !submitting && setOpen(false)}
      footer={null}
      centered
      width={480}
      title={
        <div className="flex items-center gap-3">
          <span className="p-2 rounded-lg border border-amber-200 bg-[#FFFAEB] text-[#DC6803]">
            <UserCheck size={20} />
          </span>
          <div>
            <p className="text-[1rem] font-semibold text-gray-900 mb-0">
              Edit Student Details
            </p>
            <p className="text-[.75rem] font-normal text-gray-500 mb-0">
              {student?.userIdentifier || student?.userId || "N/A"}
            </p>
          </div>
        </div>
      }
    >
      <div className="mt-6">
        {/* Email & Student ID display only */}
        {/* <div className="bg-gray-50 border border-gray-100 rounded-lg p-3 mb-4 text-[.8rem]">
          <div className="flex justify-between items-center py-1">
            <span className="text-gray-500">Email:</span>
            <span className="font-medium text-gray-800">
              {student?.email || student?.emailId || "N/A"}
            </span>
          </div>
          {student?.studentId && (
            <div className="flex justify-between items-center py-1">
              <span className="text-gray-500">Student ID:</span>
              <span className="font-medium text-gray-800">
                {student.studentId}
              </span>
            </div>
          )}
        </div> */}

        {/* First & Last Name */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label className="text-[.82rem] font-medium text-gray-700">
              First Name <span className="text-red-500">*</span>
            </label>
            <Input
              className="mt-1 py-[.38rem]"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              disabled={submitting}
            />
          </div>
          <div>
            <label className="text-[.82rem] font-medium text-gray-700">
              Last Name <span className="text-red-500">*</span>
            </label>
            <Input
              className="mt-1 py-[.38rem]"
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              disabled={submitting}
            />
          </div>
        </div>

        {/* Mobile Number */}
        <div className="mt-3">
          <label className="text-[.82rem] font-medium text-gray-700">
            Mobile Number
          </label>
          <Input
            className="mt-1 py-[.38rem]"
            placeholder="e.g. 9876543210"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            disabled={submitting}
          />
        </div>
      </div>

      <div className="flex items-center justify-end gap-3 mt-6 pt-3 border-t border-gray-100">
        <button
          type="button"
          disabled={submitting}
          className="btn-white px-4 py-2 rounded-lg text-[.85rem]"
          onClick={() => setOpen(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={submitting}
          onClick={handleSave}
          className="btn-orange px-5 py-2 rounded-lg text-[.85rem] font-medium"
        >
          {submitting ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </Modal>
  );
};

export default EditStudentModal;
